export async function runLoginSubmission(
  submitting: { current: boolean },
  submit: () => Promise<void>,
): Promise<void> {
  if (submitting.current) return

  submitting.current = true
  try {
    await submit()
  } finally {
    submitting.current = false
  }
}
